import {Backend} from './Backend';
import AppAuthToken from './AppAuthToken';
import AppBackend from './AppBackend';

export default function() {
  // return Promise.resolve(new Backend(AppAuthToken.getAuthData()));
  return Promise.resolve(AppBackend);
}



// WEBPACK FOOTER //
// ./src/App/Services/BackendFactory.js